import jwtDecode from "jwt-decode";

export function tokenIsValid(token) {
    const { exp } = jwtDecode(token);

    // La date d'expiration est en milliseconde
    return exp * 1000 > new Date().getTime();
}